module.exports = __webpack_public_path__ + "static/ARB_PHOTOGRAPHY_1-c733328d48efea795602955147cbaa50.jpg";